// extracted by mini-css-extract-plugin
export default {"modal":"CorrectElevation--modal--xSbDt"};